import { devChunkLoadErrors } from './dev-chunk-load-errors.js';
import { loginFailures } from './login-failures.js';
import { braintreeTeardownRace } from './braintree-teardown-race.js';

const filters = [devChunkLoadErrors, loginFailures, braintreeTeardownRace];

// This could be changed to return a modified event but for now
// the filters are just boolean to determine whether to send the event.
// If any filter returns false, the event will not be sent.
export function filterEvent(event, hint) {
  try {
    return filters.every((f) => f(event, hint)) ? event : null;
  } catch (e) {
    // just to be safe: if any of the filters throw an error send the event
    console.error(e);
    return event;
  }
}
